import '../styles/edgeTable.css';

import ArrowDown from '@mui/icons-material/ArrowDownwardRounded';
import ArrowUp from '@mui/icons-material/ArrowUpwardRounded';
import Recycle from '@mui/icons-material/AutorenewRounded';
import moment from 'moment';
import PropTypes from 'prop-types';
import {Badge, Button, Table} from 'react-bootstrap';
import {isMonitoredLifecycle} from '../constants/edgesConstants';
import {lifecycleStates} from '../../../shared/constants/lifecycleStates';

const EdgeTable = ({edgeData, sortOption, setSortOption, updateBalenaStatus}) => {
  const handleSort = (key) => {
    setSortOption(sortOption === `${key}_asc` ? `${key}_desc` : `${key}_asc`);
  };

  const getSortIcon = (key) => {
    if (sortOption === `${key}_asc`) return <ArrowUp fontSize="small" className="ms-1"/>;
    if (sortOption === `${key}_desc`) return <ArrowDown fontSize="small" className="ms-1"/>;
    return null;
  };

  if (!edgeData.length) return <div className="text-muted">No results found...</div>;

  return (
    <div className="table-responsive rounded shadow-sm">
      <Table className="align-middle mb-0 rounded overflow-hidden" hover>
        <thead>
          <tr>
            <th onClick={() => handleSort('name')} style={{cursor: 'pointer'}}>ID {getSortIcon('name')}</th>
            <th onClick={() => handleSort('status')} style={{cursor: 'pointer'}}>Status {getSortIcon('status')}</th>
            <th onClick={() => handleSort('address')} style={{cursor: 'pointer'}}>Address {getSortIcon('address')}</th>
            <th onClick={() => handleSort('ip')} style={{cursor: 'pointer'}}>LAN IP {getSortIcon('ip')}</th>
            <th onClick={() => handleSort('update')} style={{cursor: 'pointer'}}>Last Update {getSortIcon('update')}</th>
            <th onClick={() => handleSort('lifecycle')} style={{cursor: 'pointer'}}>Lifecycle {getSortIcon('lifecycle')}</th>
          </tr>
        </thead>
        <tbody>
          {edgeData.map((edge) => {
            const ts = edge.currentStates?.deadmanCheck?.timestamp;
            const tsDate = ts?.toDate ? ts.toDate() : ts;
            const formattedTimestamp = ts ? moment(tsDate).format('DD.MM.YYYY HH:mm:ss') : 'N/A';
            const isMonitored = isMonitoredLifecycle(edge.lifecycle?.status);
            const hasStatus = !!edge.currentStates?.deadmanCheck;
            const isOnline = isMonitored && edge.currentStates?.deadmanCheck?.type !== 401;

            const getStatusProps = () => {
              if (!isMonitored || !hasStatus) return {bg: 'secondary', label: 'Unknown'};
              return isOnline ? {bg: 'success', label: 'Online'} : {bg: 'danger', label: 'Offline'};
            };

            const status = getStatusProps();

            return (
              <tr key={edge.id}>
                <td className="fw-semibold">{edge.name}</td>
                <td>
                  <Badge pill bg={status.bg}>{status.label}</Badge>
                </td>
                <td>{edge.address || '–'}</td>
                <td>
                  <div className="d-flex align-items-center">
                    <span>{edge.status?.balena?.localIp?.toString() || '–'}</span>
                    {edge.balenaUpdatePending ? (
                      <div
                        className="loader ms-2"
                        style={{width: '1rem', height: '1rem', borderWidth: '0.15em'}}
                      />
                    ) : (
                      <Button
                        size="sm"
                        variant="link"
                        className="p-0 ms-2 text-secondary"
                        title="Update Balena Status"
                        onClick={() => updateBalenaStatus(edge.id)}
                      >
                        <Recycle fontSize="small"/>
                      </Button>
                    )}
                  </div>
                </td>
                <td>{formattedTimestamp}</td>
                <td>
                  {edge.lifecycle?.status ? (
                    <Badge bg={lifecycleStates[edge.lifecycle.status]}>{edge.lifecycle.status}</Badge>
                  ) : '–'}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

EdgeTable.propTypes = {
  edgeData: PropTypes.array.isRequired,
  sortOption: PropTypes.string.isRequired,
  setSortOption: PropTypes.func.isRequired,
  updateBalenaStatus: PropTypes.func.isRequired,
};

export default EdgeTable;
